var render = function render(){var _vm=this,_c=_vm._self._c;return _c('item-title',{attrs:{"title":_vm.workItemTitle,"disabled":!_vm.canUpdate,"use-h1":_vm.useH1},on:{"title-changed":_vm.updateTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }